import { css } from "@emotion/core";
import { fontSizes, fonts, color } from "../../theme/Theme";

export const RegistrationStyles = css({
  padding: "0 18%", // To get more horizontal padding than is possible by using util classes.
  ".title": {
    fontSize: fontSizes.eligibilityLabel,
    fontFamily: fonts.bold
  },
  ".title-underline": {
    height: "0.25rem",
    width: "4rem",
    backgroundColor: color.primary
  },
  ".name-field": {
    flexGrow: 10
  },
  ".verified": {
    color: color.successTextGreen,
    textAlign: "right"
  }
});
